import React from 'react';
import styled from 'styled-components';
import {Card, CardActionButton, ListCard, ListItem, Spin} from '../elements';
import { AppState } from '../../store';
import { connect } from 'react-redux';
import { SearchResultInterface } from '../../store/base/types';
import { CONSTS } from '../elements/_constants';
import { changeSearchQueryAction } from '../../store/base/actions';

type searchResultComponentProps = {
    className?: string,
    searchResult :SearchResultInterface,
    onQueryChange: Function,
    isSearching: boolean,
    q :string
}
const IsSearching = () => (
    <div style={{padding:15, color:CONSTS.colors.primary}}>درحال جستجو...</div>
)
const NoResult = () => (
    <div style={{padding: 15, color:CONSTS.colors.greyDark}}>نتیجه‌ای پیدا نشد!</div>
)
const MinLengthErr = () => (
    <div style={{padding: 15, color:CONSTS.colors.greyDarker}}>حداقل ۳حرف برای جستجو وارد کنید.</div>
)
const SearchResultComponent = (props: searchResultComponentProps) => {
    const {posts, forms, categories, form_datas} = props.searchResult;
    const isEmpty = forms.length === 0 && posts.length === 0 && categories.length === 0 && form_datas.length === 0;
    const handleCancleSearch = () => {
        props.onQueryChange('');
    }
    return(
        <div className={props.className}>
           <Card
            title={`نتایج جستجو: ${props.q}`}
            headerMeta={<>
                <CardActionButton title="انصراف" onClick={handleCancleSearch} iconClassName="icon-icons8-cancel" hasBorderRight={true}/>
            </>}>
                    {props.isSearching ? <IsSearching /> :
                        props.q.length < 3 ? <MinLengthErr /> :
                            isEmpty ? <NoResult /> :
                            <>
                                {categories.length > 0 &&
                                    <ListCard items={categories} renderItem={ (cat :any)=> 
                                        (<ListItem to={`/categories/${cat.id}`}>{cat.title}</ListItem>)
                                    } />
                                }
                                {forms.length > 0 && <ListCard items={forms} renderItem={ (form :any)=> 
                                        (<ListItem to={`/categories/${form.category_id}/forms/${form.id}`}>{form.title}</ListItem>)
                                    } />
                                }
                                {posts.length > 0 && <ListCard items={posts} renderItem={ (post :any)=> 
                                        (<ListItem to={`/categories/${post.category_id}/posts/${post.id}`}>{post.title}</ListItem>)
                                    } />
                                }
                                {form_datas.length > 0 && <ListCard items={form_datas} renderItem={ (obj :any)=> 
                                        (<ListItem to={`/categories/${obj.category_id}/forms/${obj.form_id}/items/${obj.id}`}>{obj.title}</ListItem>)
                                    } />
                                }
                                
                            </>}
            </Card>
        </div>
    )}

const SearchResult = styled(SearchResultComponent)`
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
        /* margin: 15px; */
    }
    .widget-items {
        padding-bottom: 10px;
        width: calc(100% + 14px);
        margin-right: -7px;
        padding-top: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        flex-flow: row wrap;
        align-items: flex-start;
        align-content: flex-start;
    }

`
const mapDispatchToProps = (dispatch :Function) => ({
    onQueryChange: (q:string) => dispatch(changeSearchQueryAction(q)),
})
export default connect(null,mapDispatchToProps)(SearchResult);